import { Box, FormControl, InputLabel, TextField } from '@mui/material'
import { FC, useCallback, useEffect } from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import {
  PaymentOptionsType,
  PaymentProvider,
  PaymentProviderType,
} from '../../third-party/PaymentProvider'
import { PaymentProviderFactory } from '../../third-party/PaymentProviderFactory'
import { CardExpiryInput } from '../CardExpiryInput'
import { CardInput } from '../CardInput'

const CreditCardFields: FC<CreditCardFieldsProps> = (props) => {
  const { payment, onSucceed, onError } = props

  const { t } = useTranslation()

  const handleError = useCallback(
    (error: unknown) => {
      toast.error(String(error))
      onError(error)
    },
    [onError]
  )

  useEffect(() => {
    ;(async () => {
      const paymentOptions: PaymentOptionsType = {
        ...payment,
        method: 'card',
        onSucceed,
        handleError,
      }
      await PaymentProviderFactory.initPaymentProvider(
        payment.method,
        paymentOptions
      )
    })()
  }, [handleError, onSucceed, payment])

  return (
    <>
      <TextField
        label={t('Name on card')}
        id={PaymentProvider.formIds.NAME_ON_CARD}
        required
      />
      <FormControl required>
        <InputLabel>{t('Card number')}</InputLabel>
        <CardInput required />
      </FormControl>
      {payment.method !== 'ezypay' && (
        <TextField
          label={t('CVV number')}
          name="cvv"
          id={PaymentProvider.formIds.CARD_CCV}
          required
          slotProps={{
            htmlInput: {
              minLength: 3,
              maxLength: 4,
              pattern: '\\d+',
            },
          }}
        />
      )}
      <Box my={2}>
        <InputLabel required>{t('Expiry date')}</InputLabel>
        <CardExpiryInput />
      </Box>
    </>
  )
}

type CreditCardFieldsProps = {
  payment: { method: PaymentProviderType }
  onSucceed: (result: any) => void
  onError: (error: unknown) => void
}

export { CreditCardFields }
export type { CreditCardFieldsProps }
